import React, { Component } from 'react'
import {Button} from 'primereact/button';
import ReactLoading from 'react-loading';
import { PaiementLoyerService } from '../service/PaiementLoyerService';


/*
 * Page de retour après paiement sur la passerelle FASO ARZEKA.
 * Le statut définitif vient du webhook côté serveur : on interroge donc
 * /paiement/statut jusqu'à ce qu'il soit tranché.
 */
const DELAI_POLL = 3000;
const NB_POLL_MAX = 20;

export class RetourPaiement extends Component {

    constructor() {
        super();
        this.state = {
            echeance : null,
            attente : true,
            nbTentatives : 0,
            introuvable : false
        }
        this.paiementLoyerService = new PaiementLoyerService();
        this.verifier = this.verifier.bind(this);
    }

    componentDidMount() {
        const stocke = localStorage.getItem('idEcheanceEnCours');
        if (!stocke) {
            this.setState({attente : false, introuvable : true});
            return;
        }
        this.idEcheanceLoyer = JSON.parse(stocke);
        this.verifier(true);
        this.timer = setInterval(() => this.verifier(false), DELAI_POLL);
    }
    componentWillUnmount() {
        this.arreter();
    }
    arreter() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    verifier(premierAppel) {
        this.paiementLoyerService.getStatut(this.idEcheanceLoyer).then(echeance => {
            // l'UI se base sur statutPaiement ; on ne poursuit que tant qu'il est EN_COURS
            const statut = echeance.statutPaiement;
            const termine = statut !== "EN_COURS";

            // au premier passage, on demande au proxy de rafraîchir sa vision du paiement
            if (premierAppel && !termine && echeance.mappedOrderId) {
                this.paiementLoyerService.rafraichirCallback(echeance.mappedOrderId)
                    .catch(error => { console.log(error) })
            }

            const nbTentatives = this.state.nbTentatives + 1;
            if (termine || nbTentatives >= NB_POLL_MAX) {
                this.arreter();
                if (statut === "PAYE") {
                    localStorage.removeItem('idEcheanceEnCours');
                }
                this.setState({echeance : echeance, attente : false, nbTentatives : nbTentatives});
                return;
            }
            this.setState({echeance : echeance, nbTentatives : nbTentatives});
        })
        .catch(error => {
            console.log(error);
            this.arreter();
            this.setState({attente : false, introuvable : true});
        })
    }

    renderResultat() {
        const echeance = this.state.echeance;
        if (this.state.introuvable || !echeance) {
            return (
                <div>
                    <h2>Paiement non identifié</h2>
                    <p>Nous n'avons pas pu retrouver le paiement. Consultez l'état de vos échéances depuis votre échéancier.</p>
                </div>
            );
        }
        const montant = Number(echeance.montant).toLocaleString('fr-FR') + " FCFA";
        if (echeance.statutPaiement === "PAYE") {
            return (
                <div>
                    <h2 style={{color : "green"}}>Paiement effectué</h2>
                    <p>Votre paiement de <b>{montant}</b> a bien été enregistré.
                       {echeance.quittanceDisponible ? " Votre quittance est téléchargeable depuis votre échéancier." : ""}</p>
                </div>
            );
        }
        if (echeance.statutPaiement === "IMPAYE") {
            return (
                <div>
                    <h2 style={{color : "red"}}>Paiement non abouti</h2>
                    <p>Le paiement de <b>{montant}</b> n'a pas été finalisé. Vous pouvez le relancer depuis votre échéancier.</p>
                </div>
            );
        }
        return (
            <div>
                <h2 style={{color : "#b58900"}}>Paiement en cours de validation</h2>
                <p>Le paiement de <b>{montant}</b> n'est pas encore confirmé par la passerelle.
                   Revenez sur votre échéancier dans quelques minutes pour vérifier.</p>
            </div>
        );
    }

    render() {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-8 p-lg-6">
                    <div className="card card-w-title">
                        <h1>Retour de paiement</h1>
                        {this.state.attente ?
                            <div>
                                <p>Vérification du paiement en cours...</p>
                                <ReactLoading type="spin" color="black" height={50} width={50} />
                            </div>
                            :
                            this.renderResultat()
                        }
                        <Button label="Retour à mon échéancier" icon="pi pi-arrow-left" style={{width : "250px", marginTop : "15px"}}
                                onClick={() => { window.location = "#/paiement-loyer" }} />
                    </div>
                </div>
            </div>
        )
    }
}

export default RetourPaiement
